import { Component } from '@angular/core';
@Component({
    selector: 'TravelProposalForm',
    templateUrl: './TravelProposalForm.html',
    styleUrls: ['./TravelProposalForm.css']
  })
export class TravelProposalForm
{

public isShowLoading:boolean=false;

public ReviewInfo:boolean=false;


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelProposalForm/TravelProposalForm.ts